import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { LOG_LEVELS, TEXT_AREA_TOOL_TIP } from '../../util/constants';

@Component({
  selector: 'app-show-grade',
  templateUrl: './show-grade.component.html',
  styleUrls: ['./show-grade.component.scss']
})
export class ShowGradeComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldIds: string[];
  iconClicked = false;
  tellUsMore = '';
  rateExperience = '';
  textToolTip = TEXT_AREA_TOOL_TIP;
  verySatisfied = 'Very satisfied';
  satisfied = 'Satisfied';
  dissatisfied = 'Dissatisfied';
  veryDissatisfied = 'Very dissatisfied';

  constructor(
    private ngaugeService: NGaugeService,
    private logService: LogService,
    public dialogRef: MatDialogRef<ShowGradeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.applyDefaultGradeColor();
    if (this.data['value']['tellUsMore'] !== null) {
      this.tellUsMore = this.data['value']['tellUsMore'];
    }
    if (this.data['value']['rateExperience'] !== null) {
      this.gradeReceived(this.data['value']['rateExperience']);
    }
  }

  gradeReceived(field) {
    this.applyDefaultGradeColor();
    this.fieldIds.forEach(fieldId => {
      if (fieldId === field) {
        const element = document.getElementById(field);
        this[field] = `${this[field]} !`;
        element.classList.add('grade-icon');
        this.rateExperience = fieldId;
        this.iconClicked = true;
      }
    });
  }

  applyDefaultGradeColor() {
    this.fieldIds = ['verySatisfied', 'satisfied', 'dissatisfied', 'veryDissatisfied'];
    this.verySatisfied = 'Very satisfied';
    this.satisfied = 'Satisfied';
    this.dissatisfied = 'Dissatisfied';
    this.veryDissatisfied = 'Very dissatisfied';
    this.fieldIds.forEach(fieldId => {
      const element = document.getElementById(fieldId);
      element.classList.remove('grade-icon');
      element.classList.add('default');
    });
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

  public onClickConfirm(): void {
    const response = { tellUsMore: this.tellUsMore, rateExperience: this.rateExperience };
    this.dialogRef.close(response);
  }

  pasteClipboardContent() {
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Helpcenter Grade - TellUsMore', 'Paste');
    this.ngaugeService.getClipboardContent().then(text => {
      this.tellUsMore += this.tellUsMore + text;
    });
  }

  ngOnDestroy() {
    this.fieldIds = null;
    this.iconClicked = null;
    this.tellUsMore = null;
    this.rateExperience = null;
    this.dialogRef = null;
    this.data = null;
    this.textToolTip = null;
    this.ngaugeService = null;
    this.verySatisfied = null;
    this.satisfied = null;
    this.dissatisfied = null;
    this.veryDissatisfied = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/show-grade/show-grade.component.ts